import { defineStore } from 'pinia'
import { ref, type Ref, computed } from 'vue'
import { useLocaleStore } from '@/stores'
import { type Maybe, type Nft, Address, CoinAmount } from '@/types'

export const useNFTSignTxStore = defineStore('sign/nftTransaction', () => {
  const localeStore = useLocaleStore()
  const prospect: Ref<Maybe<Nft>> = ref()
  const toAddress: Ref<Address> = ref(new Address(''))
  const sendAmount: Ref<string> = ref('0')

  // Gas
  const gasLimit: Ref<string> = ref('0')
  const gasPrice: Ref<CoinAmount> = ref(
    new CoinAmount({ amount: '0', decimal: 0 }),
  ) as Ref<CoinAmount>

  const setProspect = (nft: Nft) => {
    clear()
    prospect.value = nft
  }

  const gasOptions = ref<{
    high: CoinAmount
    medium: CoinAmount
    low: CoinAmount
  }>({
    high: new CoinAmount({
      amount: '0',
      decimal: 0,
    }),
    medium: new CoinAmount({
      amount: '0',
      decimal: 0,
    }),
    low: new CoinAmount({
      amount: '0',
      decimal: 0,
    }),
  })

  const gasName: Ref<string> = ref('') // an alias for gas option
  const fee: Ref<string> = computed(() => {
    // total
    return gasPrice.value.ethValue.multipliedBy(gasLimit.value).toFixed()
  })
  // nonce
  const nonce: Ref<string> = ref('0')

  function clear() {
    prospect.value = undefined
    toAddress.value = new Address('')
    sendAmount.value = '0'
  }

  function getCurrency() {
    return localeStore.localeInfo?.unit
  }

  async function prepare() {
    if (!prospect.value) {
      throw new Error('Prospect needed to be set before sign')
    }
    return prospect.value.getPrepareData({
      to: toAddress.value.toString(),
      amount: sendAmount.value,
    })
  }

  return {
    prospect,
    clear,
    setProspect,
    toAddress,
    sendAmount,
    getCurrency,
    prepare,
    gasLimit,
    gasPrice,
    gasOptions,
    gasName,
    fee,
    nonce,
  }
})
